























































import { computed, ComputedRef, defineComponent, ref, Ref, toRefs } from '@vue/composition-api';
import AppButton from '@/components/AppButton.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import SelectInput from '@/components/SelectInput.vue';
import TextInput from '@/components/TextInput.vue';
import { load } from '@/directives/loading';
import { useChangeBookingStatus, useGetBookingCancellationReasons } from '@/features/bookings';
import { BookingStatus } from 'graphql-types.gen';
import { useAlerts } from '@/features/alerts';
import { useEventBus } from '@/features/events';

/**
 * Confirming the status change whichever the new status is
 */
export default defineComponent({
  name: 'ConfirmStatusPopup',
  components: {
    AppButton,
    ModalDialog,
    SelectInput,
    TextInput,
  },
  directives: {
    load,
  },
  model: {
    prop: 'modelValue',
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    bookingUid: {
      type: String,
      required: true,
    },
    // toggle schedule button
    isReschedule: {
      type: Boolean,
      default: false,
    },
    isJumpstart: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { bookingUid } = props;
    const { modelValue } = toRefs(props);
    const statusMessages: Record<string, string> = {
      confirmed: 'هل أنت متأكد أنك تريد تأكيد الحجز؟',
      canceled: 'هل أنت متأكد أنك تريد إلغاء الحجز؟',
      completed: 'هل أنت متأكد أنك تريد تغيير حالة الحجز إلى مكتمل؟',
      missed: 'هل أنت متأكد أنك تريد تغيير حالة الحجز إلى عدم الحضور؟',
    };

    const model: ComputedRef<string | boolean> = computed({
      get() {
        return modelValue.value;
      },
      set(value) {
        emit('input', value);
      },
    });

    const { changeBookingStatus, isChangingStatus } = useChangeBookingStatus();
    const { success, error } = useAlerts();
    const { emit: emitCustomEvent } = useEventBus();

    /**
     * This part is specifically for changing to `canceled` status
     */
    const { reasons, isFetchingReasons, fetchReasons } = useGetBookingCancellationReasons();
    if (modelValue.value === 'canceled') {
      fetchReasons();
    }
    const customReason: Ref<string> = ref('');
    const reasonForCancellation: Ref<string> = ref('');
    const isCustomReason: ComputedRef<boolean> = computed(() => reasonForCancellation.value === 'أخرى');
    const disableChange: ComputedRef<boolean> = computed(() => {
      const isCanceled = modelValue.value === 'canceled';
      const isReasonGiven = isCustomReason.value ? !!customReason.value : !!reasonForCancellation.value;
      return isCanceled && !isReasonGiven;
    });
    /********/

    async function doChangeStatus() {
      try {
        await changeBookingStatus({
          booking_uid: bookingUid,
          status: (modelValue.value as string).toUpperCase() as BookingStatus,
          cancellation_reason: reasonForCancellation.value,
          ...(isCustomReason.value && { comment: customReason.value }),
        });
        success('تم تحديث حالة الحجز');
        emit('input', null);
        emitCustomEvent('BOOKINGS_UPDATED');
      } catch (err) {
        error('هناك خطأ ما');
      }
    }

    // on reschedule button call to action
    const onRescheduleAction = () => {
      emit('input', false);
      emit('onRescheduleAction', bookingUid);
    };

    return {
      statusMessages,
      isChangingStatus,
      doChangeStatus,
      reasons,
      isFetchingReasons,
      customReason,
      reasonForCancellation,
      isCustomReason,
      disableChange,
      model,
      onRescheduleAction,
    };
  },
});
